import { render, staticRenderFns } from "./CreatedByChannelChart.vue?vue&type=template&id=12460056&scoped=true&"
import script from "./CreatedByChannelChart.vue?vue&type=script&lang=js&"
export * from "./CreatedByChannelChart.vue?vue&type=script&lang=js&"
import style0 from "./CreatedByChannelChart.vue?vue&type=style&index=0&id=12460056&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12460056",
  null
  
)

export default component.exports